import { ArtistInfoBadges } from '@app/components/ArtistBadges';
import { ArtistBadgeStatus } from '@app/data/clients/rbServerSideClient/types';
import { Box, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';

const messages = defineMessages({
  achievements: {
    defaultMessage: 'Achievements',
  },
});

interface ArtistAchievementsProps {
  badgeStatuses: ArtistBadgeStatus[];
}

export const ArtistAchievements: React.FC<ArtistAchievementsProps> = ({
  badgeStatuses,
}) => {
  const intl = useIntl();

  if (badgeStatuses.length === 0) return null;

  return (
    <>
      <Box paddingTop="xl">
        <Text type="display3">{intl.formatMessage(messages.achievements)}</Text>
      </Box>
      <Box paddingTop="m">
        <ArtistInfoBadges
          fanArtist={badgeStatuses.includes('fanArtArtist')}
          featuredArtist={badgeStatuses.includes('featuredArtist')}
        />
      </Box>
    </>
  );
};
